import dayjs from '@wconcept/wconcept-common/libs/dayjs';

// isToday
export const isToday = (_date: string) => {
  const date = dayjs(_date).format('YYYY-MM-DD');
  const now = dayjs().format('YYYY-MM-DD');
  return now === date;
};

// getDateWeek
export const getDateWeek = (
  _date: string,
  // eslint-disable-next-line default-param-last
  type: 'live' | 'event' | 'brand-live' = 'live',
  lang?: string
) => {
  let date = '';
  let week = '';
  if (type === 'live') {
    if (lang === 'Kr') {
      date = dayjs(_date).format('M월 DD일 ');
      week = dayjs(_date).locale('ko').format('ddd요일');
    } else {
      date = dayjs(_date).format('M.DD ');
      week = dayjs(_date).format('ddd').toUpperCase();
    }
  }
  if (type === 'event') {
    if (lang === 'Kr') {
      date = dayjs(_date).format('M월 D일 ');
      week = dayjs(_date).locale('ko').format('(ddd)');
    } else {
      date = dayjs(_date).format('MM.DD ');
      week = dayjs(_date).format('ddd').toUpperCase();
    }
  }
  if (type === 'brand-live') {
    if (lang === 'Kr') {
      date = dayjs(_date).format('M/D');
      week = dayjs(_date).locale('ko').format('(ddd)');
    } else {
      date = dayjs(_date).format('M/D');
      week = dayjs(_date).format('ddd').toUpperCase();
    }
  }

  return date + week;
};

// getDateAm
export const getDateAm = (_date: string) => {
  const date = dayjs(_date);
  const hour = date.get('hour');
  return hour < 12 ? '오전' : '오후';
};

// getDateTime
export const getDateTime = (_date: string) => {
  const date = dayjs(_date);
  const Hour = date.get('hour');
  const Minute = date.get('minute');

  const dateValue = `${Hour > 12 ? Hour - 12 : Hour}:${
    Minute > 9 ? Minute : `0${Minute}`
  }`;

  return dateValue;
};

// Date converting (date : YYYY-MM-DD HH:MM:SS)
export const getFullDate = (date?: string) => {
  if (!date) {
    return '';
  }
  return `${isToday(date) ? 'TODAY' : getDateWeek(date)} ${getDateAm(
    date
  )} ${getDateTime(date)}`;
};

export const getLiveFullDate = (date?: string, finish = false) => {
  if (date && !finish) {
    const d = dayjs(date);

    // 요일을 한글로 변환
    const weekdays = ['일', '월', '화', '수', '목', '금', '토'];
    const weekday = weekdays[d.day()];

    // 시간대 설정 (오전/오후/저녁)
    const timeOfDay = getDateAm(date);

    // 시간을 12시간제로 변환하고, 분이 한 자리일 경우 0을 붙여 포맷팅
    const hour = d.hour() % 12 || 12; // 12시간제로 변환 (0일 경우 12로 표시)
    const minute = d.minute() < 10 ? `0${d.minute()}` : d.minute(); // 분이 한 자리일 때 0을 붙임

    // 날짜 포맷팅
    return d.format(`M/D(${weekday}) ${timeOfDay} ${hour}:${minute}`);
  }

  if (date && finish) {
    const d = dayjs(date);

    // 요일을 한글로 변환
    const weekdays = ['일', '월', '화', '수', '목', '금', '토'];
    const weekday = weekdays[d.day()];

    // 날짜 포맷팅
    return d.format(`M/D(${weekday})`);
  }

  return '';
};

export const getEventFullDate = (date?: string, type: 'event' = 'event') => {
  if (!date) {
    return '';
  }
  return `${
    isToday(date) ? 'TODAY' : getDateWeek(date, type, 'Kr')
  } ${getDateAm(date)} ${getDateTime(date)}`;
};

// checkStatus
export const checkStatus = (_stat: string, _date: string) => {
  const date = dayjs(_date).format('YYYY-MM-DD HH:mm:ss');
  const now = dayjs().format('YYYY-MM-DD HH:mm:ss');
  if (_stat === 'ONAIR' && now <= date) return 'READY';
  return _stat;
};
